import Stats from "../models/Stats";

const StatsStore = Stats.create();

export default StatsStore;